import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 3,
  style: {"max-height":"50vh","overflow":"auto"}
}
const _hoisted_2 = {
  key: 4,
  style: {"color":"#c62828","margin-top":"8px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.modalShow,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalShow) = $event)),
    width: "1200",
    persistent: ""
  }, {
    default: _withCtx(() => [
      (_ctx.bulkUploadLocations && _ctx.model)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { "primary-title": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("message.uploadLocationsCsv")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.uploadLocationsCsvInformation")), 1),
                  _createVNode(_component_v_select, {
                    variant: "outlined",
                    density: "compact",
                    modelValue: _ctx.fileFormatCulture,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileFormatCulture) = $event)),
                    items: _ctx.languages,
                    label: _ctx.$t('message.fileFormatCulture'),
                    "prepend-icon": "mdi-flag"
                  }, null, 8, ["modelValue", "items", "label"]),
                  _createVNode(_component_v_file_input, {
                    modelValue: _ctx.file,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.file) = $event)),
                    accept: ".csv,text/csv",
                    label: _ctx.$t('message.selectCsvFile'),
                    variant: "outlined",
                    density: "compact",
                    "show-size": "",
                    onChange: _ctx.onFileSelected,
                    "prepend-icon": "mdi-file-delimited-outline"
                  }, null, 8, ["modelValue", "label", "onChange"]),
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    modelValue: _ctx.scenarioName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scenarioName) = $event)),
                    label: _ctx.$t('message.scenarioName'),
                    rules: [_ctx.scenarioNameRule]
                  }, null, 8, ["modelValue", "label", "rules"]),
                  (_ctx.parseError)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "error",
                        density: "compact",
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.parseError), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.cultureWarning)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "warning",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.cultureWarning), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.propertyColumns.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 2,
                        type: "info",
                        density: "compact",
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.uploadLocationsCsvDetectedProperties", { names: _ctx.propertyColumns.map(p => p.title || p.name).join(', ') })), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.rows.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_data_table, {
                          headers: _ctx.headers,
                          items: _ctx.rows,
                          "items-per-page": -1,
                          "hide-default-footer": "",
                          density: "compact"
                        }, _createSlots({
                          [`item.name`]: _withCtx(({ item }) => [
                            _createVNode(_component_v_text_field, {
                              density: "compact",
                              "hide-details": "",
                              modelValue: item.name,
                              "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                              error: !item.name
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])
                          ]),
                          [`item.locationGroup`]: _withCtx(({ item }) => [
                            _createVNode(_component_v_select, {
                              density: "compact",
                              "hide-details": "",
                              items: _ctx.locationGroupItems,
                              "item-title": "name",
                              "item-value": "id",
                              modelValue: item.locationGroup,
                              "onUpdate:modelValue": ($event: any) => ((item.locationGroup) = $event),
                              error: !item.locationGroup
                            }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "error"])
                          ]),
                          [`item.longitude`]: _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(item.longitude), 1)
                          ]),
                          [`item.latitude`]: _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(item.latitude), 1)
                          ]),
                          _: 2
                        }, [
                          _renderList(_ctx.propertyColumns, (prop) => {
                            return {
                              name: _ctx.propSlotName(prop),
                              fn: _withCtx(({ item }) => [
                                (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 'p' + prop.id,
                                  density: "compact",
                                  "hide-details": "",
                                  type: prop.dataType === 0 ? 'text' : 'number',
                                  modelValue: item.props[prop.id],
                                  "onUpdate:modelValue": ($event: any) => ((item.props[prop.id]) = $event)
                                }, null, 8, ["type", "modelValue", "onUpdate:modelValue"]))
                              ])
                            }
                          })
                        ]), 1032, ["headers", "items"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.invalidRowCount > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("message.uploadLocationsCsvInvalidRows", { count: _ctx.invalidRowCount })), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                  (!_ctx.model.scenarioHierarchy)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        variant: "text",
                        disabled: !_ctx.canSave || _ctx.rootScenarioId == null,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit(_ctx.rootScenarioId)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.save")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : (_openBlock(), _createBlock(_component_v_menu, {
                        key: 1,
                        color: "primary",
                        location: "bottom",
                        "close-on-content-click": false,
                        modelValue: _ctx.menu,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.menu) = $event))
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({ variant: "text" }, props, {
                            color: "primary",
                            disabled: !_ctx.canSave,
                            onClick: _withModifiers(_ctx.toggleMenu, ["stop"])
                          }), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.save")) + " ", 1),
                              _createVNode(_component_v_icon, { right: "" }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("mdi-chevron-down", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 16, ["disabled", "onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    variant: "text",
                                    color: "primary",
                                    disabled: _ctx.rootScenarioId == null,
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit(_ctx.rootScenarioId)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.saveAddToNewScenario")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    variant: "text",
                                    color: "primary",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit(_ctx.scenario.id))),
                                    disabled: _ctx.scenario.parentScenarioId == null
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.saveAddToNewNestedScenario")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _ctx.close
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}